import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberInputComponent } from './number-input.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [NumberInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InlineSVGModule,
    FGBSharedModule
  ],
  exports: [NumberInputComponent],
})
export class NumberInputModule {}
